import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorMessage: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.error-state.error-message.non-final',
		defaultMessage: 'Unable to load data',
		description: 'Error message when epic details fails to load',
	},
	tryAgain: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.error-state.try-again.non-final',
		defaultMessage: 'Try again',
		description: 'Try again button to refetch epic details when it fails to load',
	},
});
